import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';

import { RenderedFormService } from '@app/shared/components/rendered-form/rendered-form.service';

import { StepperSectionComponent } from './stepper-section.component';

@Component({
  encapsulation: ViewEncapsulation.None,
  exportAs: 'fl-stepper',
  selector: 'fl-stepper',
  styleUrls: ['./stepper.component.scss'],
  templateUrl: './stepper.component.html'
})
export class StepperComponent implements OnInit, AfterViewInit {
  @Input() form: any;

  @ContentChildren(StepperSectionComponent) sections: QueryList<StepperSectionComponent>;

  constructor(
    private renderer: Renderer2,
    public el: ElementRef,
    public renderedFormService: RenderedFormService
  ) {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    // TODO: This should be removed in favor of setting the visible section from the parent component
    // so we aren't depending on a global state for active elements
    this.updateVisibleSection();
  }

  get visibleSections(): any[] {
    let { form, renderedFormService } = this;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return form.sections.filter((s) => renderedFormService.objectIsVisible(s));
  }

  navigateNext(): void {
    this.navigate(1);
  }

  navigateBack(): void {
    this.navigate(-1);
  }

  navigate(step: any): void {
    const { sections } = this;

    this.renderedFormService.activeSectionIndex += step;
    if (this.renderedFormService.activeSectionIndex >= sections?.length - 1) {
      this.renderedFormService.activeSectionIndex = sections?.length - 1;
    }
    if (this.renderedFormService.activeSectionIndex < 0) {
      this.renderedFormService.activeSectionIndex = 0;
    }

    this.updateVisibleSection();
  }

  toggleParentContainerWidth(toggle: any): void {
    let parentWrapper = this.el.nativeElement.closest('.wrapper');
    let action;

    if (toggle !== null) {
      action = 'add';
    } else {
      action = 'remove';
    }

    parentWrapper.classList[action]('full-width');
  }

  // TODO: Change to be paired with note on line 38
  updateVisibleSection(): void {
    const { renderer, sections } = this;

    sections.forEach((section, index) => {
      if (this.renderedFormService.activeSectionIndex === index) {
        renderer.addClass(section.el.nativeElement, 'active');
      } else {
        renderer.removeClass(section.el.nativeElement, 'active');
      }
    });
  }
}
